import React, { useState, useEffect, useRef } from "react";
import Loading from "../../common/Loading";
import { useTranslation } from "../../../contexts/TranslationProvider";
import EventManager from "../../../services/EventManager";
// import csv from "csv.png"


const FormExportModal = ({ onClose }) => {
  const modalref = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalref.current && !modalref.current.contains(event.target)) {
        onClose()
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalref]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();


  const handleExportCSV = async () => {
    EventManager.invoke('ExportCSV', true)
  };
  const handleExportDocx = async () => {
    EventManager.invoke('ExportDocx', true)
  };



  return (
    <>
      <>
        <div id="contractz-lab" ref={modalref} className="contractz-lab-export" style={{ position: "absolute", top: "9vh", right: "35vh" }}>
          <div className="modal-dialog export-modal-specific">
            <div className="modal-content" style={{ width: "fit-content" }}>
              <div className="modal-header header-export" >
                <h5 className="modal-title export-title">{t("pages.editionForm.export.title")}</h5>
              </div>
              {loading ? (
                <Loading height="50vh" />
              ) : (
                <div className="modal-body body-export">
                  <div className="form-group">
                    <p className="export-contract-text">{t("pages.editionForm.export.description")}</p>
                    <div className="form-floating mb-3 export-buttons">
                      <button className="btn export-btn" onClick={handleExportCSV} style={{ margin: "10px 0px" }}>
                        <div className="csv-img"></div>
                        <p>{t("pages.editionForm.export.exportCSV")}</p>
                      </button>

                      <>
                        <button className="btn export-btn" onClick={handleExportDocx} style={{ margin: "10px 0px" }}>
                          <div className="word-img"></div>
                          <p>{t("pages.editionForm.export.exportWord")}</p>
                        </button>
                      </>

                    </div>
                    <p className="export-contract-text">{t("pages.editionForm.export.footer")}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default FormExportModal;
